
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import ContratTemplate from '@/extend/classes/ContratTemplate';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeContratTemplate' })

export default class storeContratTemplate extends VuexModule {
  // States
  private reccords: ContratTemplate[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get contratTemplateLoading (): boolean {
    return this.dataLoading;
  }
  private get contratTemplateRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get contratTemplateLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewContratTemplate() {
    return (): ContratTemplate => { 
      return this.getContratTemplate(0, true);
    }
  }

  
  public get getContratTemplate () {
    return (id: number, canCreate = false): ContratTemplate => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id ContratTemplate can't be 0")
        return new ContratTemplate();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new ContratTemplate();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            ContratTemplate.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromContratTemplate(data.reccords[0] as ContratTemplate);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listContratTemplate (): ContratTemplate[] {
    return this.reccords;
  }

  public get listConfigContratTemplate (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mContratTemplateRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mContratTemplateClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mContratTemplateLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mContratTemplateLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(ContratTemplate.fromJson(reccord as ContratTemplate));
    })
    ContratTemplate.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mContratTemplateConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mContratTemplateCreated (obj: ContratTemplate): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareContratTemplate(obj)) {
          api.fromContratTemplate(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareContratTemplate(obj)) {
            api.fromContratTemplate(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mContratTemplateUpdated (obj: ContratTemplate): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareContratTemplate(obj)) {
          api.fromContratTemplate(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mContratTemplateDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerContratTemplate (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.contratTemplateRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerContratTemplate(this.contratTemplateCreated, this.contratTemplateUpdated, this.contratTemplateDeleted);
          this.mContratTemplateRegistered();
        } else {
          setTimeout(() => resolve(this.registerContratTemplate(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.contratTemplateLoading && !this.contratTemplateLoaded) {
          this.mContratTemplateLoading(true);
          return ContratTemplate.list(filter)
            .then((data: ListData) => {
              this.mContratTemplateLoaded(data);
              this.mContratTemplateLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredContratTemplate (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.contratTemplateLoading) {
        this.mContratTemplateLoading(true);
        return ContratTemplate.list(filter)
          .then((data: ListData) => {
            this.mContratTemplateLoaded(data);
            this.mContratTemplateLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createContratTemplate (obj: ContratTemplate): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      return ContratTemplate.fromJson(obj).createForStoreContratTemplate()
        .then((reccords) => {
          this.mContratTemplateCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateContratTemplate (obj: ContratTemplate): Promise<ContratTemplate> {
    return new Promise((resolve, reject) => {
      return ContratTemplate.fromJson(obj).updateForStoreContratTemplate()
        .then((reccords) => {
          this.mContratTemplateUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteContratTemplate (obj: ContratTemplate): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return ContratTemplate.fromJson(obj).deleteForStoreContratTemplate()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mContratTemplateDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private contratTemplateCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mContratTemplateConfigUpdated(config)
    const obj = objConfig.obj as ContratTemplate;
    this.mContratTemplateCreated(ContratTemplate.fromJson(obj));
  }

  @Action
  private contratTemplateUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mContratTemplateConfigUpdated(config)
    const obj = objConfig.obj as ContratTemplate;
    this.mContratTemplateUpdated(ContratTemplate.fromJson(obj));
  }

  @Action
  private contratTemplateDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as ContratTemplate;
    this.mContratTemplateDeleted(obj.id);
  }
}
